module.exports = __webpack_public_path__ + "media/images/logo-4c0fed537718bc11c9b98f7311f67ff8.svg";